import {ManipulationEditor} from "./ManipulationEditor";

const SNAP_DISTANCE = 6;

/**
 * Manipuation editor for all objects manipulable by a bounding box
 */
export class BoxedObjectEditor extends ManipulationEditor {

	/**
	 * @param {boolean} movable		- object can be moved
	 * @param {boolean} resizable	- object can be resized using handlers
	 */
	constructor(parent, movable, resizable) {
		super(parent);
		this.movable = movable;
		this.resizable = resizable;
	}


	hit(x, y) {
		const bb = this.calcBoundingBox();
		if (BoxedObjectEditor.boxHit(bb, x, y)) return this;
		return null;
	}

	static boxHit(bb, x, y) {
		return x >= bb.left && x < (bb.left + bb.width)
			&& y >= bb.top && y < (bb.top + bb.height);
	}

	get x() {
		return 0;
	}

	get y() {
		return 0;
	}

	set x(val) {
	}

	set y(val) {
	}


	startDragging() {
		this.startX = this.x;
		this.startY = this.y;
	}

	drag(diffX, diffY, snapsX, snapsY) {
		const snap = super.drag(diffX, diffY, snapsX, snapsY);
		const oldX = this.x;
		const oldY = this.y;
		this.x = this.startX + diffX;
		this.y = this.startY + diffY;
		BoxedObjectEditor.snap(this.x, snapsX, (newValue)=>{
			snap.x = newValue;
			this.x = newValue;
		});
		BoxedObjectEditor.snap(this.y, snapsY, (newValue)=>{
			snap.y = newValue;
			this.y = newValue;
		});
		if (oldX !== this.x || oldY !== this.y) this.positionDragged(oldX, oldY, this.x, this.y);
		return snap;
	}

	positionDragged(oldX, oldY, x, y) {
	}

	static snap(value, snaps, action) {
		let snap = 0;
		let snapDist = 500000;
		for (let s of snaps) {
			let distance = Math.abs(value - s);
			if (distance <= snapDist) {
				snap = s;
				snapDist = distance;
			}
		}
		if (snapDist <= SNAP_DISTANCE) action(snap);
	}

	stopDragging(diffX, diffY, snapsX, snapsY) {
		this.drag(diffX, diffY, snapsX, snapsY);
	}

	static boundingBox(centerX, centerY, width, height) {
		const box = {};
		box.left = centerX - (width / 2);
		box.top = centerY - (height / 2);
		box.width = width;
		box.height = height;
		return box;
	}

	static strokeBox(centerX, centerY, width, height, strokeWidth) {
		const box = BoxedObjectEditor.boundingBox(centerX, centerY, width, height);
		box.left += (strokeWidth / 2);
		box.top += (strokeWidth / 2);
		box.width -= strokeWidth;
		box.height -= strokeWidth;
		return box;
	}


	verticalSnaps() {
		const snaps = super.verticalSnaps();
		snaps.push(this.y);
		return snaps;
	}

	horizontalSnaps() {
		const snaps = super.horizontalSnaps();
		snaps.push(this.x);
		return snaps;
	}
}